import { api, config } from '../../../helpers/api';

export async function getWorkStartDateRequest(departmentId = null) {
  const response = await api.get(
    '/occasions/work_start_date',
    config('json', {
      department_id: departmentId
    })
  );
  return response.data;
}

export async function getDepartmentsRequest(id) {
  const response = await api.get(
    `/organization/${id}/department`,
    config('json')
  );

  return response.data;
}
